import * as React from "react";
import { Dropdown } from "react-bootstrap";
import { BiChevronDown, BiChevronUp } from "react-icons/bi";

const ResourcesDropdown = ({
  showResourcesMenu,
  setShowResourcesMenu,
  setShowProductMenu,
}) => {
  const handleOnClickResources = () => {
    setShowResourcesMenu((prev) => !prev);
    setShowProductMenu(false);
  };

  const dropdownRef = React.useRef(null);

  React.useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setShowResourcesMenu(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [dropdownRef]);
  return (
    <>
      <Dropdown show={showResourcesMenu} ref={dropdownRef}>
        <Dropdown.Toggle
          variant="default"
          id="dropdown-basic"
          onClick={() => handleOnClickResources()}
         className={`${showResourcesMenu && 'active'}`}
        >
          Resources
          <span className="ml-10" >{showResourcesMenu ? <BiChevronUp/> : <BiChevronDown />}</span>
        </Dropdown.Toggle>

        <Dropdown.Menu>
          <Dropdown.Item href="https://blog.webbermill.com/" target="_blank">Blog</Dropdown.Item>
          <Dropdown.Item href="#">Events</Dropdown.Item>
          <Dropdown.Item href="#">Webinars</Dropdown.Item>
          <Dropdown.Item href="#">Partners</Dropdown.Item>
        </Dropdown.Menu>
      </Dropdown>
    </>
  );
};

export default ResourcesDropdown;
